import {useState, useEffect} from 'react';
import {useParams, useLocation} from 'react-router-dom';
import {
  usePostIngestionCopy,
  usePostIngestionEdit,
} from '../../../../hooks/ingestions/useIngestions';
import {IIngestionCopyResponse} from '../../../../api/types/ingestionApi.type';

export const useIngestionDataLoad = () => {
  const location = useLocation();
  const {ingestionId: routeIngestionId} = useParams<{ingestionId: string}>();

  // ✅ Case-insensitive route detection
  const pathname = location.pathname.toLowerCase();
  const isCopyFlow = pathname.includes('/copy/');
  const isEditFlow = pathname.includes('/edit/');
  const isDataLoadFlow = isCopyFlow || isEditFlow;

  const [dataLoaded, setDataLoaded] = useState(false);
  const [loadedData, setLoadedData] = useState<IIngestionCopyResponse | null>(
    null
  );

  // Unified success handler
  const handleDataLoadSuccess = (data: IIngestionCopyResponse) => {
    setLoadedData(data);
    setDataLoaded(true);
  };

  // Unified error handler
  const handleDataLoadError = () => {};

  // Mutations
  const copyMutation = usePostIngestionCopy(
    handleDataLoadSuccess,
    handleDataLoadError
  );

  const editMutation = usePostIngestionEdit(
    handleDataLoadSuccess,
    handleDataLoadError
  );

  // Load data on mount
  useEffect(() => {
    if (!routeIngestionId || dataLoaded) return;

    const ingestionIdNum = parseInt(routeIngestionId, 10);

    if (isCopyFlow) {
      copyMutation.mutate({ingestionId: ingestionIdNum});
    } else if (isEditFlow) {
      editMutation.mutate({ingestionId: ingestionIdNum});
    }
  }, [isCopyFlow, isEditFlow, routeIngestionId, dataLoaded]);

  return {
    isCopyFlow,
    isEditFlow,
    isDataLoadFlow,
    isLoading: copyMutation.isPending || editMutation.isPending,
    loadedData,
    dataLoaded,
  };
};
